<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li v-for="item in lista" :key="item.id" class="breadcrumb-item">
                <router-link class="link-secondary link-underline-opacity-25" :to="item.link">{{item.name}}</router-link>
            </li>
        </ol>
    </nav>
    
</template>

<script>
export default {
    name: "Breadcrumb",
    props: {
        lista: Array
    }
}
</script>